import React from "react";

export const IconMobile = () => {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M17 2H8C7.40326 2 6.83097 2.23705 6.40901 2.65901C5.98705 3.08097 5.75 3.65326 5.75 4.25V20.75C5.75 21.3467 5.98705 21.919 6.40901 22.341C6.83097 22.7629 7.40326 23 8 23H17C17.5967 23 18.169 22.7629 18.591 22.341C19.0129 21.919 19.25 21.3467 19.25 20.75V4.25C19.25 3.65326 19.0129 3.08097 18.591 2.65901C18.169 2.23705 17.5967 2 17 2ZM17.75 20.75C17.75 20.9489 17.671 21.1397 17.5303 21.2803C17.3897 21.421 17.1989 21.5 17 21.5H8C7.80109 21.5 7.61032 21.421 7.46967 21.2803C7.32902 21.1397 7.25 20.9489 7.25 20.75V4.25C7.25 4.05109 7.32902 3.86032 7.46967 3.71967C7.61032 3.57902 7.80109 3.5 8 3.5H17C17.1989 3.5 17.3897 3.57902 17.5303 3.71967C17.671 3.86032 17.75 4.05109 17.75 4.25V20.75ZM13.625 6.125C13.625 6.3475 13.559 6.56501 13.4354 6.75002C13.3118 6.93502 13.1361 7.07922 12.9305 7.16436C12.725 7.24951 12.4988 7.27179 12.2805 7.22838C12.0623 7.18498 11.8618 7.07783 11.7045 6.9205C11.5472 6.76316 11.44 6.56271 11.3966 6.34448C11.3532 6.12625 11.3755 5.90005 11.4606 5.69448C11.5458 5.48891 11.69 5.31321 11.875 5.1896C12.06 5.06598 12.2775 5 12.5 5C12.7984 5 13.0845 5.11853 13.2955 5.3295C13.5065 5.54048 13.625 5.82663 13.625 6.125Z"
                fill="#08212D"
            />
        </svg>
    );
};
